export enum Service {
  JobByBrand = 'ConsentImports:ByBrand',
  JobBySite = 'ConsentImports:BySite',
  Messages = 'ConsentImports:Messages',
}
